import React, { useEffect, useRef, useState } from 'react';

import { useAuthService } from '@bessemercws/auth';
import { useClientContext } from '@bessemercws/providers';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { ExternalNavigate } from './ExternalNavigate';

export interface RequireAuthProps {
  children: JSX.Element;
  redirectTo: string;
}

export const RequireAuth = ({ children, redirectTo }: RequireAuthProps): JSX.Element | null => {
  const authService = useAuthService();
  const navigate = useNavigate();
  const { exchangeCodeForToken } = authService;
  const { setIsAdvisor, setIdToken, setIsAuthing, isAuthing } = useClientContext();
  const [searchParams, setSearchParams] = useSearchParams();
  const checkedAuth = useRef(false);
  
  useEffect(() => {
    setIsAdvisor(true);
    setIsAuthing(false);
  }, []);
  
  const samlCode = searchParams.get('code');
  const congnitoState = searchParams.get('state');
  const [loading, setLoading] = useState<boolean>(!!samlCode);
  
  const handleExchangeComplete = (token: string) => {
    setIdToken(token);
  };

  useEffect(() => {
    const checkAuthentication = async (code: string) => {
      // removes code from url or navigates to a cognito state
      if (congnitoState) { navigate(congnitoState); } else { setSearchParams(); }
      
      checkedAuth.current = true;
      await exchangeCodeForToken(code, handleExchangeComplete);

      setLoading(false);
    };

    if (samlCode && !checkedAuth.current) checkAuthentication(samlCode);
  }, [samlCode, loading, authService, setSearchParams]);
  
  if (isAuthing || loading) {
    return <></>;
  }

  return <>{authService.isTokenValid(true) ? children : <ExternalNavigate to={redirectTo} />}</>;
};
